import { render } from "./DashboardContador.vue?vue&type=template&id=2b0869eb"
import script from "./DashboardContador.vue?vue&type=script&lang=js"
export * from "./DashboardContador.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__